import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type {
  FanguardApiContractsTicketTicketGroupDetailModel,
  FanguardApiContractsTicketTicketGroupSummaryModel,
} from 'src/api/generated';

export const TICKET_GROUPS_URI = 'ticket-group';

export const ticketGroupsQueries = createQueryKeys(TICKET_GROUPS_URI, {
  all: null,
  list: {
    queryKey: ['list'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsTicketTicketGroupSummaryModel[]>({
        uri: TICKET_GROUPS_URI,
      });
      return response.data;
    },
  },
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsTicketTicketGroupDetailModel>({
        uri: `${TICKET_GROUPS_URI}/${id}`,
      });
      return response.data;
    },
  }),
});
